import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AppContainerService } from '@mydocma/app-container';
import { TreeOptions } from '@mydocma/component-library/src/lib/tree';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { StructureNode } from './structure.model';
import { StructureService } from './structure.service';

@UntilDestroy()
@Component({
  selector: 'mydocma-co-structure',
  templateUrl: './structure.component.html',
  styleUrls: ['./structure.component.scss']
})
export class StructureComponent implements OnInit, OnDestroy {

  @Input() treeOptions: TreeOptions;

  public structuresTree: StructureNode[] = [] ;

  public isDataLoading$: Observable<boolean>;

  public selectedStructureTreeNode: StructureNode;

  constructor(
    private readonly appContainerService: AppContainerService,
    private readonly structureService: StructureService,
  )
  {
    this.structureService.structuresTree$
    .pipe(untilDestroyed(this))
    .subscribe(strTree=>{
      if (!strTree ) {
        this.structuresTree = [];
      } else {
        this.selectedStructureTreeNode = this.structureService.selectedStructure;
        this.structuresTree = [strTree];
      }
    })
  }
  ngOnDestroy(): void {

  }

  async ngOnInit() {
  }

  public onCloseClick() {
    this.appContainerService.closeContentSideNav();
  }

  public onStructureClick(structure) {
    this.structureService.selectedStructure = structure;
  }

}
